import React from "react";
import styles from "./adStatusLabel.scss";
import { AdStatus } from "../../../../../models";

const AdStatusLabel = ({ status }) => {
  const getStatusString = (value: number) => {
    switch (value) {
      case AdStatus.active:
        return "Aktivan";
      case AdStatus.paused:
        return "Pauziran";
      case AdStatus.sold:
        return "Prodano";
      case AdStatus.expired:
        return "Istekli";
      default:
        return "";
    }
  };

  const getStatusStyle = (value: number) => {
    switch (value) {
      case AdStatus.active:
        return styles.activeLabel;
      case AdStatus.paused:
        return styles.pausedLabel;
      case AdStatus.sold:
        return styles.soldLabel;
      case AdStatus.expired:
        return styles.expiredLabel;
      default:
        return null;
    }
  };

  return (
    <span className={`${styles.statusWrapper}`}>
      <div className={`${styles.statusCircle} ${getStatusStyle(status)}`} />
      <span>{getStatusString(status)}</span>
    </span>
  );
};

export default AdStatusLabel;



// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/MyAdsCard/AdStatusLabel/AdStatusLabel.tsx